import { render, staticRenderFns } from "./ReferenceInformation.vue?vue&type=template&id=3ff0918a"
import script from "./ReferenceInformation.vue?vue&type=script&lang=js"
export * from "./ReferenceInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports